import Ex1 from './ex1'
import Ex2 from './Ex2'
import FormationEx1 from './FormationEx1'
import TabEx1 from './TabEx1'
import ModalEx1 from './ModalEx1'

export default {
  Ex1,
  Ex2,
  FormationEx1,
  TabEx1,
  ModalEx1
}



/** WEBPACK FOOTER **
 ** ./src/examples/index.js
 **/